import {
  AccordionDetails,
  AccordionSummary,
  makeStyles,
  Typography,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import {
  FiX
} from "react-icons/fi";
import { connect } from "react-redux";
import { useAuth } from "../../../../context/auth";
import { actionShowSpinner } from "../../../../redux-flow/action/Wrapper/Spinner";
import { getById } from "../../../../services/minutes.service";
import { checkAccess } from "../../utils/index";
import CustomAccordion from "../../slots/SlotCommitteeDetails/CustomAccordion";
import Actions from './Actions';
import FinalDeliberation from './FinalDeliberation';
import GeneralComment from './GeneralComment';
import SlotApproval from './SlotApproval';

const EditAction = ({
  t,
  actionShowSpinner,
  slotId,
  minuteId,
  minuteSlotId,
  comitteeSlotId,
  slotType,
  onClose
}) => {
  const { userAccess } = useAuth();
  const classes = useStyles();

  const [canApprove, setCanApprove] = useState(false);
  const [canListActions, setCanListActions] = useState(false);
  const [slotTheme, setSlotTheme] = useState('');
  const [generalComment, setGeneralComment] = useState('');
  const [finalDeliberation, setFinalDeliberation] = useState('');
  const [actions, setActions] = useState([]);

  const [minuteStatus, setMinuteStatus] = useState('');

  const getData = () => {
    getById(minuteSlotId).then(res => {
      setGeneralComment(res.generalComments);

      setFinalDeliberation(res.finalDeliberation);

      const formattedActions = [];

      for (const action of res?.actions) {
        formattedActions.push({
          ...action,
          firstResponsible: action.firstResponsible || '',
          secoundResponsible: action.secondResponsible || '',
        });
      };

      setActions(formattedActions);
    }).finally(() => actionShowSpinner(false));
  }

  useEffect(() => {
    if(userAccess){
      const hasAccess = checkAccess(userAccess, 'saveApprovers');
      const hasAccessToListActions = checkAccess(userAccess, 'listActionsInMinutes');

      setCanListActions(hasAccessToListActions)

      if(hasAccess && slotType === 'A'){
        setCanApprove(true);
      }

      actionShowSpinner(true);

      getById(minuteSlotId).then(res => {
        setMinuteStatus(res.status);

        setGeneralComment(res.generalComments);

        setFinalDeliberation(res.finalDeliberation);

        setSlotTheme(res.slotTheme);

        const formattedActions = [];

        for (const action of res?.actions) {
          formattedActions.push({
            ...action,
            firstResponsible: action.firstResponsible || '',
            secoundResponsible: action.secondResponsible || '',
          });
        };

        setActions(formattedActions);
      }).finally(() => actionShowSpinner(false));
    };
  }, [minuteSlotId, slotType, userAccess]);

  return (
    <div style={{ width: '100%' }}>
      <div style={{width: '100%', alignItems: 'center', display: 'flex', justifyContent: 'space-between', marginBottom: 20}}>
        <Typography variant="h4">
          {`Informações do slot ${slotTheme}`}
        </Typography>
        <FiX color="#465EB6" size={26} style={{cursor: 'pointer'}} onClick={onClose}/>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}>
        <CustomAccordion defaultExpanded aria-describedby="generalCommentSection">
          <AccordionSummary expandIcon={<KeyboardArrowDownIcon />}>
            <Typography className={classes.subtitle}>
              {t("forms.minutes.actions.generalComments")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ display: 'block' }}>
            <GeneralComment
              minuteStatus={minuteStatus}
              setGeneralComment={setGeneralComment}
              minuteSlotId={minuteSlotId}
              generalComment={generalComment}
              minuteId={minuteId}
              slotId={slotId}
            />
          </AccordionDetails>
        </CustomAccordion>

        <CustomAccordion disabled={!canListActions} aria-describedby="actionsSection">
          <AccordionSummary expandIcon={<KeyboardArrowDownIcon />}>
            <Typography className={classes.subtitle}>
              {t("forms.minutes.actions.actions")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ display: 'block' }}>
            <Actions
              minuteStatus={minuteStatus}
              minuteSlotId={minuteSlotId}
              actions={actions}
              minuteId={minuteId}
              slotId={slotId}
              updateData={getData}
            />
          </AccordionDetails>
        </CustomAccordion>

        <CustomAccordion disabled={!canApprove} aria-describedby="finalDeliberationSection">
          <AccordionSummary expandIcon={<KeyboardArrowDownIcon />}>
            <Typography className={classes.subtitle}>
              {t("forms.minutes.actions.finalDeliberation")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ display: 'block' }}>
            <FinalDeliberation
              minuteStatus={minuteStatus}
              setFinalDeliberation={setFinalDeliberation}
              minuteSlotId={minuteSlotId}
              comitteeSlotId={comitteeSlotId}
              finalDeliberation={finalDeliberation}
              minuteId={minuteId}
              slotId={slotId}
              actionShowSpinner={actionShowSpinner}
            />
          </AccordionDetails>
        </CustomAccordion>

        <CustomAccordion disabled={!canApprove} aria-describedby="votesSection">
          <AccordionSummary expandIcon={<KeyboardArrowDownIcon />}>
            <Typography className={classes.subtitle}>
              {t("forms.minutes.actions.votes")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ display: 'block' }}>
            <SlotApproval
              minuteStatus={minuteStatus}
              slotToApproval={{comitteeSlotId: comitteeSlotId}}
              actionShowSpinner={actionShowSpinner}
              t={t}
            />
          </AccordionDetails>
        </CustomAccordion>
      </div>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  subtitle: {
    font: "Inter",
    fontWeight: "bold",
    fontSize: "14.52px",
    color: "#4460BF",
    lineHeight: "17.57px",
  },
}));

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const ActionsConnect = connect(
  null,
  mapDispatchToProps
)(EditAction);

export default withTranslation()(ActionsConnect);
